"use client"

import { motion } from "framer-motion"
import { useAppSelector } from "@/app/store/hooks"

export function GreetingSection({ selectedDeckType }: { selectedDeckType: string }) {
    const { user } = useAppSelector((state) => state.auth)


    function getSubtitleOnDeckType() {
        switch (selectedDeckType) {
            case "Presentation":
                return "Let’s Bring Your Vision Alive"
            case "documents":
                return "Tell us more about your document"
            case "fundraising-pitch-deck":
            case "business-pitch-deck":
                return "Let's make an investor-ready deck"
            case "business-pitch-deck":
                return "Let's introduce your business"
            case "deep-research":
                return "What's your topic of interest?"
            default:
                return "What type of deck do you need?"
        }
    }


    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="text-center"
        >
            <h1 className="text-3xl md:text-[42px] font-bold tracking-tight text-slate-900 dark:text-white">
                Hi{user?.firstName ? `, ${user.firstName}` : " there"}
            </h1>
            <h2 className={`text-3xl md:text-[42px] font-bold tracking-tight ${selectedDeckType == "fundraising-pitch-deck" ? "text-blue-500" : "text-blue-500"}`}>
                {getSubtitleOnDeckType()}
            </h2>
        </motion.div>
    )
}
